import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { ModalContext } from '@/utils/contexts/ModalContext';

import Spinner from '@/views/components/Spinner/Spinner';

import api from '@/services/api';

import styles from '@/views/components/Modal/ModalDelete.module.scss';

const ModalDeleteLetter = () => {
	const { dict } = useSelector((state) => state.app);
	const [ requestIsPending, setRequestIsPending ] = useState(false);
	const navigate = useNavigate();

	const { closeModal, modalAdditionalInfo: { id } } = useContext(ModalContext);
	const deleteFile = () => {
		setRequestIsPending(true);
		api.delete(`/letters/${id}`).then(() => {
			closeModal();
			navigate('/letters', { replace: true });
			setRequestIsPending(false);
		});
	};

	return (
		<div className='modal__content modal__delete-file--deleteLetter'>
			{ requestIsPending && (
				<div className='letter__edit-metadata--spinner'>
					<Spinner />
				</div>
			) }
			<div className={ styles['delete'] }>
				<h3 className={ styles['delete--title-deleteLetter'] }>
					{dict.modals.deleteLetter.head}
				</h3>

				<div className={ `${styles['delete--comment']} ${styles['delete--text']}` }>
					<p>{dict.modals.deleteLetter.comment1}</p>
					<p>{dict.modals.deleteLetter.comment2}</p>
				</div>

				<section className={ styles['delete--buttons'] }>
					<div
						className='button__std'
						onClick={
							closeModal
						}
					>
						{dict.cancel}
					</div>
					<div
						className='button__blue'
						onClick={ deleteFile }
					>
						{dict.modals.deleteLetter.delete}
					</div>
				</section>
			</div>
		</div>
	);
};

export default ModalDeleteLetter;